import { Controller } from "web-ui/controller"
import * as Log from "web-ui/log"

export default class extends Controller {
  static events = {
    "change": "change"
  }

  connect() {
    this.debug("Connect")
  }

  change() {
    this.debug("Submit")
    this.element.requestSubmit()
  }

  disconnect() {
    this.debug("Disconnect")
  }

  debug(message, data) {
    Log.debug("Passive Submission Form - " + message, data)
  }
}
